import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { LookInside } from './components/LookInside';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { Reviews } from './components/Reviews';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { leaderVoices, moreLeaderVoices } from './data/testimonials';
export function App() {
  return <div className="min-h-screen w-full bg-paper font-sans text-pine selection:bg-ember selection:text-pine" data-id="element-0" data-mp="3mlj8gtrwtb2j">
      <MetaPixel data-id="element-1" data-mp="3rcj8i7wbs999" />
      <main data-id="element-2" data-mp="3rbznujfaj6rj">
        <Hero data-id="element-3" data-mp="3rdkhm6ts6loc" />
        <SocialProofBar data-id="element-4" data-mp="3rcsulke91w9o" />
        <PainGrid data-id="element-5" data-mp="3relv0hy9rk98" />
        <ProductReveal data-id="element-6" data-mp="5orv1p50w72" />
        <LookInside data-id="element-7" data-mp="4wv3njt0sf7" />
        <Tomes data-id="element-8" data-mp="5gg5d4r3wxg" />
        <Bonuses data-id="element-9" data-mp="82kl3wchwbg" />
        <ValueStack data-id="element-10" data-mp="2zl3azit8d249" />
        <Urgency data-id="element-11" data-mp="2zllcouynw8jk" />
        <Pricing data-id="element-12" data-mp="2zm4xcjfp5b1a" />
        <Reviews data-id="element-13" data-mp="2zmo5j8fjol24" />
        <Testimonials voices={leaderVoices} background="white" data-id="element-14" data-mp="2zn6cayzu2hoa" />
        <Guarantee data-id="element-15" data-mp="33ngdzzglelxc" />
        <Faq data-id="element-16" data-mp="33mykhalbelt4" />
        <Testimonials voices={moreLeaderVoices} title="Every tech hits the same wall" background="panel" data-id="element-17" data-mp="33oi337ug18y2" />
        <CostOfInaction data-id="element-18" data-mp="3dl4kfmnk9hvc" />
        <Close data-id="element-19" data-mp="3dmfqjt4hb1pm" />
      </main>
      <Footer data-id="element-20" data-mp="3dii4ozqinw21" />
      <PurchaseNotifications data-id="element-21" data-mp="nvsvva68mxyl" />
    </div>;
}